import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {AddContentStore} from '../../../x7/content-parts/AddContentStore';
import {FlashcardsEditStore} from './FlashcardsEditStore';
import {flashcardsEditStoreRenderer} from './FlashcardsEditStoreRenderer';

@observer
export class FlashcardsCreate extends React.Component<{ store: AddContentStore }> {
  readonly store: FlashcardsEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: AddContentStore }>) {
    super(props);
    this.store = new FlashcardsEditStore();
    this.disposers.add(this.store);
    this.setup();
  }

  render() {
    return Array.from(flashcardsEditStoreRenderer(this.store));
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
